import {
  getManualsBaseUrl,
  routePathToManualKey,
} from '@/utils/manual/config'
import { ExcelManual, ScreenTourManual } from '@/utils/manual/types'

export class ManualLoadError extends Error {
  status: number | null

  constructor(message: string, status: number | null = null) {
    super(message)
    this.name = 'ManualLoadError'
    this.status = status
  }
}

async function fetchJson<T>(url: string): Promise<T> {
  let response: Response
  try {
    response = await fetch(url, { method: 'GET', credentials: 'omit' })
  } catch (e) {
    throw new ManualLoadError(
      'マニュアルの取得に失敗しました（ネットワークエラー）'
    )
  }

  // 専用バケットは未配置のキーも 403 を返す
  if (response.status === 404 || response.status === 403) {
    throw new ManualLoadError(
      'この画面のマニュアルはまだ登録されていません',
      response.status
    )
  }
  if (!response.ok) {
    throw new ManualLoadError(
      `マニュアルの取得に失敗しました（HTTP ${response.status}）`,
      response.status
    )
  }

  return (await response.json()) as T
}

/** 画面ツアー定義を取得する */
export async function loadScreenTour(
  routePath: string
): Promise<ScreenTourManual> {
  const key = routePathToManualKey(routePath)
  const url = `${getManualsBaseUrl()}/${key}.tour.json`
  return fetchJson<ScreenTourManual>(url)
}

/** Excel 説明定義を取得する */
export async function loadExcelManual(
  routePath: string
): Promise<ExcelManual> {
  const key = routePathToManualKey(routePath)
  const url = `${getManualsBaseUrl()}/${key}.excel.json`
  return fetchJson<ExcelManual>(url)
}

/** 相対画像パスをマニュアル配信上の絶対 URL にする */
export function resolveManualAssetUrl(
  routePath: string,
  relativeOrAbsolute: string
): string {
  if (
    relativeOrAbsolute.startsWith('http://') ||
    relativeOrAbsolute.startsWith('https://') ||
    relativeOrAbsolute.startsWith('/')
  ) {
    return relativeOrAbsolute
  }
  const key = routePathToManualKey(routePath)
  const dir = key.includes('/') ? key.replace(/\/[^/]+$/, '') : key
  return `${getManualsBaseUrl()}/${dir}/${relativeOrAbsolute}`
}
